import { Button, maxLength, maxValue, minValue, NumberInput, required, TextInput, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import GradingIcon from "@mui/icons-material/Grading";
import { studentRequests } from "api/studentApi";

const UpdateClassGradeDialog = ({ label, classId, educationId, fetchDisciplineData, grade }) => {
  const notify = useNotify();
  const isEdit = grade !== null && grade !== undefined;

  const handleSubmit = async data => {
    const payload = {
      studentEducationId: educationId,
      grade: data.grade,
      note: isEdit ? null : data.note,
    };

    await dataProvider.customRequest(studentRequests.updateClassGrade(classId), payload, "PUT");
    notify(`Успешно ${isEdit ? "променихте" : "добавихте"} оценка`, { type: "success" });
    fetchDisciplineData();
  };

  return (
    <FormModal
      titleContent={label}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          variant="contained"
          startIcon={<GradingIcon />}
          size="small"
          label={label}
        />
      }
    >
      <NumberInput
        source="grade"
        label="Оценка"
        step="0.01"
        validate={[required(), minValue(2, "Минималната оценка е 2.00"), maxValue(6, "Максималната оценка е 6.00")]}
        parse={value => (value === "" ? null : parseFloat(value))}
      />
      {!isEdit && (
        <TextInput
          source="note"
          label="Бележка"
          validate={[required(), maxLength(400)]}
          fullWidth
        />
      )}
    </FormModal>
  );
};

export default UpdateClassGradeDialog;
